import React, { ReactElement } from 'react';
import HTMLReactParserSafe from '../../partials/html-react-parser-safe';

interface Props {
  keyNum: number,
  title: string,
  description: string,
  isActive: boolean,
  activeToggleCallback: (key: number) => void,
}

const BreedGuideCard: React.FC<Props> = (data): ReactElement => {
  const {
    keyNum,
    title,
    description,
    isActive,
    activeToggleCallback,
  } = data;

  return (
    <div className={`carousel-item-custom breed-guide-card ${isActive ? 'active' : ''} key-class--${keyNum}`}>
      <h3 style={{ paddingTop: '20px !important' }}>{title}</h3>
      <div className="desc-box">
        <HTMLReactParserSafe html={description} />
      </div>
      <a
        href="#"
        className="read-more-link"
        onClick={(e) => {
          e.preventDefault();
          activeToggleCallback(keyNum);
        }}
      >
        {isActive ? 'Read Less' : 'Read More'}
      </a>
    </div>
  );
};

export default BreedGuideCard;
